module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-bnr-0b6f470e7cae20b58d7d20dd796bf035.png";